import authAxios, { authHeader } from "./data";
import qs from "qs";

const dynamicFields = async () => {
  const response = await authAxios.get("/api/Mailings/Bulk/DynamicFields", {
    headers: authHeader()
  });

  return response.data;
};

const count = async (request: any, signal: AbortSignal) => {
  const response = await authAxios.get("/api/Mailings/Bulk/Count", {
    signal: signal,
    headers: authHeader(),
    params: request,
    paramsSerializer: (params) => qs.stringify(params)
  });

  return response.data;
};

const add = async (request: any) => {
  const response = await authAxios.post("/api/Mailings/Bulk/", request, {
    headers: authHeader()
  });
  return response.data;
};

export const MailingsBulkCreationService = {
  dynamicFields,
  count,
  add
};
